import { useFormContext, useFormField } from '@calendly/form'
import { CurrencyField } from '@calendly/ui/form/currency-field'
import { useCallback, useEffect } from 'react'

export const FormCurrencyField = ({
  amountFieldName = 'amount',
  currencyFieldName = 'currency',
  onCurrencyChange: onCurrencyChangeProp,
  id,
  ...props
}) => {
  const { setFieldValue, setFieldTouched } = useFormContext()
  const [{ value: amountValue }, { error: amountError }] = useFormField({ name: amountFieldName })
  const [{ value: currencyValue }] = useFormField({ name: currencyFieldName })

  useEffect(() => {
    const hasAmount = amountValue !== undefined && amountValue !== null && amountValue !== ''
    if (hasAmount) {
      setFieldTouched(amountFieldName, true)
    }
  }, [amountValue, amountFieldName, setFieldTouched])

  const handleAmountChange = useCallback((value) => {
    setFieldValue(amountFieldName, value)
    setFieldTouched(amountFieldName, true)
  }, [amountFieldName, setFieldValue, setFieldTouched])

  const handleCurrencyChange = useCallback((value) => {
    setFieldValue(currencyFieldName, value)
    setFieldTouched(currencyFieldName, true)

    if (onCurrencyChangeProp) {
      onCurrencyChangeProp(value)
    }
  }, [currencyFieldName, setFieldValue, setFieldTouched, onCurrencyChangeProp])

  return (
    <CurrencyField
      id={id || 'payment-amount-field'}
      value={amountValue}
      currency={currencyValue}
      error={amountError}
      onChange={handleAmountChange}
      onCurrencyChange={handleCurrencyChange}
      {...props}
    />
  )
}
